import { create } from "zustand"

/** Pixi `WheelEngine.init()` finished — used by `AppLoader` on routes that mount `PvPRouletteWheel`. */
interface PvpWheelBootstrapStore {
  pixiInitDone: boolean
  setPixiInitDone: (done: boolean) => void
}

export const usePvpWheelBootstrapStore = create<PvpWheelBootstrapStore>(
  (set) => ({
    pixiInitDone: false,
    setPixiInitDone: (pixiInitDone) => set({ pixiInitDone }),
  })
)
